import React from "react";
import { Toast } from "antd-mobile";
import { Player, ControlBar, PlaybackRateMenuButton } from "video-react";
import * as Api from "../../utils/api";
export default class VedioPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      courseInfo: {
        name: "放射科医生PET-CT初步诊断快速入门及进阶",
      },
    };
  }
  render() {
    const _this = this;
    return (
      <div className="vedioContainer" style={{ height: _this.props.height }}>
        <Player
          ref={(player) => {
            this.player = player;
          }}
          poster={Api.imageGlobalUrl + _this.props.vedioPoster}
          controls="false"
          x-webkit-airplay="true"
          x5-playsinline="true"
          playsinline="true"
          webkit-playsinline="true"
          x5-video-orientation="portraint"
          preload="auto"
          // x-webkit-airplay={true}
          x5-video-player-type="h5"
          // preload="metadata"
          // onCanPlay={() => this.handleAudioCanplay()}
          // x5-video-player-fullscreen={true}
        >
          <source src={_this.props.vedioUrl} />
          <ControlBar autoHide={false} disableDefaultControls={false}>
            {/* <ReplayControl seconds={10} order={1.1} /> */}
            {/* <ForwardControl seconds={30} order={1.2} /> */}
            {/* <PlayToggle />
              <CurrentTimeDisplay order={4.1} />
              <TimeDivider order={4.2} /> */}
            <PlaybackRateMenuButton rates={[0.5, 0.75, 1, 1.25, 1.5]} />
            {/* <VolumeMenuButton /> */}
          </ControlBar>
        </Player>
      </div>
    );
  }
  handleAudioCanplay() {
    this.player.video.play();
  }
  /**
   * 返回上一级页面
   * */
  goBack() {
    const _this = this;
    _this.props.history.goBack();
  }
}
